import React, { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import LandingPage from "../pages/landingPage";
// import Register from "../components/Auth/register";
import Login from "../components/Auth/Login/login";

import ConfirmRegistration from "../components/Auth/confirmRegistration";
import ForgotPassword from "../components/Auth/Login/forgotPassword";
import ResetPassword from "../components/Auth/Login/resetPassword";
import CookieUtil from "../utils/cookieUtil";
import PageNotFound from "../pages/pageNotFound";
import VerifyEmail from "../components/LandingPage/VerifyEmail/VerifyEmail";
const AppRoutes: React.FC = () => {
 const [isUserLoggedIn, setIsUserLoggedIn] = useState<boolean>(
            !!CookieUtil.getCookie('user_info')
        );

  return (
    
      <Routes>
      
      <Route path="/" element={<LandingPage />} />
      <Route path='/email-verify/:email_token' element={<VerifyEmail />} />
      

      {/* <Route path="/register" element={<Register />} /> */}
      
      {/*<Route path="/login" element={<Login />} />*/}
      <Route path="/success" element={<ConfirmRegistration/>} />
      <Route path="/forgot" element={<ForgotPassword/>} />
      <Route path="/password-reset/:token" element={<ResetPassword/>}/>
      <Route path="*" element={<PageNotFound />} />
    </Routes>
      
  );
};

export default AppRoutes;

